import React from "react";
import { Button, Col, Row, Typography, Form, Select, InputNumber } from "antd";
import { PlusOutlined, CloseSquareFilled } from "@ant-design/icons";
import { COLORS } from "~constants";
const { Paragraph } = Typography;

/**
 * DROPDOWN AND INPUTFIELDS FORM LIST GENERATOR
 *
 * @param {formListName}
 * @param {dropdownName}
 * @param {dropdownTitle}
 * @param {dropdownRuleMessage}
 * @param {dropdownList}
 * @param {inputFields}  = nullable
 * @returns   returns a dropdown in a form.list and it can also handle 2 more input fields
 */

const DropDownFormList = ({
  formListName,
  dropdownName,
  dropdownTitle,
  dropdownRuleMessage,
  dropdownList,
  inputFields = [],
}) => {
  return (
    <Form.List name={formListName}>
      {(fields, { add, remove }) => (
        <>
          {fields?.length > 0 && (
            <Row gutter={10} justify="space-between" align="center">
              <Col span={inputFields?.length > 0 ? 10 : 24}>
                <Paragraph level={5}>{dropdownTitle}</Paragraph>
              </Col>
              {inputFields.map((fields, index) => (
                <Col
                  key={`inputFieldName_${index}`}
                  span={12 / inputFields.length}
                >
                  <Paragraph level={5}>{fields?.name.toUpperCase()}</Paragraph>
                </Col>
              ))}
              <Col span={2}></Col>
            </Row>
          )}

          {fields.map(({ key, name, ...restField }, index) => (
            <Row gutter={10} justify="space-between" align="center" key={key}>
              <Col span={inputFields?.length > 0 ? 10 : 20}>
                <Form.Item
                  {...restField}
                  name={[name, dropdownName]}
                  rules={[
                    {
                      required: true,
                      message: dropdownRuleMessage,
                    },
                  ]}
                >
                  <Select options={dropdownList} />
                </Form.Item>
              </Col>

              {inputFields?.length > 0 &&
                inputFields.map((fields, index) => (
                  <Col
                    key={`inputFields_${index}`}
                    span={12 / inputFields.length}
                  >
                    <Form.Item
                      {...restField}
                      name={[name, fields?.name]}
                      rules={[
                        {
                          required: fields?.message && true,
                          message: fields?.message,
                        },
                      ]}
                    >
                      <InputNumber style={{ width: "100%" }} />
                    </Form.Item>
                  </Col>
                ))}

              <Col span={2}>
                <CloseSquareFilled
                  onClick={() => remove(index)}
                  style={{
                    color: COLORS.red,
                    fontSize: 25,
                    marginTop: 5,
                  }}
                />
              </Col>
            </Row>
          ))}
          <Row style={{ marginBottom: 50 }}>
            <Button
              block
              onClick={() => add()}
              type="primary"
              icon={<PlusOutlined />}
            >
              ADD MORE
            </Button>
          </Row>
        </>
      )}
    </Form.List>
  );
};

export default DropDownFormList;
